
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { OrderStateServiceV2 } from '../store/state/order/orderv2/order-state.service';

@Injectable({ providedIn: 'root' })
export class OrderStateGuard implements CanActivate {
    constructor(private orderStateServiceV2: OrderStateServiceV2, private router: Router) { }

    canActivate(
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const orderNumber = this.orderStateServiceV2.orderNumber();
        if (orderNumber) {
            return true;
        }

        // If OrderNumber is missing in session, redirect to start page
        return this.router.navigate(['welcome']);
    }
}
